import React from 'react';
import { Redirect } from 'react-router';
import { useAuth0 } from '../../../auth/auth';
import { ERoutes } from '../../../assets/constants/routes';
import { SpinnerComponent } from '../../atoms/atoms.index';
import { EErrorName } from '../../../domain/notification.interface';
import queryString from 'query-string';
import './SessionPage.component.scss';

function Spinner() {
  return (
    <div className='page-container session-page d-flex justify-content-center align-items-center'>
      <SpinnerComponent />
    </div>
  );
}

export function SessionPageComponent() {
  const params = queryString.parse(decodeURIComponent(window.location.search));
  const { loading, isAuthenticated } = useAuth0();

  if (loading) {
    return (
      <React.Fragment>
        <Spinner />
      </React.Fragment>
    );
  }

  let redirect = params.callback ? params.callback.toString() : ERoutes.HOME;
  if (params.error) {
    if (params.error_description && params.error_description.indexOf(EErrorName.EmailNotVerifyException) >= 0 && params.userId) {
      redirect = ERoutes.EMAIL_NOT_VERIFIED.replace(':userId', params.userId ? params.userId.toString() : '');
    } else if (isAuthenticated) {
      redirect = ERoutes.LOGIN_ERROR;
    } else {
      redirect = ERoutes.NOT_FOUND;
    }
  }

  console.log('Redirecting to '  + redirect);
  return (
    <React.Fragment>
      <Redirect to={redirect} />
    </React.Fragment>
  );
}
